module.exports = __webpack_public_path__ + "img/ic_company.213ad6fc.png";